module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/staff-c717cf43482691fc1763c2657abcccbd.svg";